import dayjs from 'dayjs';
import {getCookie, setCookie} from '..';

// 다중 레이어 쿠키('chk_popup')에서 현재 숨김 처리된 ID 목록을 객체로 반환
export function getHiddenPopupState(mainKey: string): Record<string, 'y'> {
  const rawValue = getCookie(mainKey);
  if (!rawValue) {
    return {};
  }

  const value = decodeURIComponent(rawValue);
  const now = dayjs();
  const pairs = value.split('&');
  return pairs.reduce((acc, pair) => {
    const parts = pair.split('=');
    if (parts.length === 2) {
      const [id, expiryTimestamp] = parts;
      if (dayjs(expiryTimestamp).isAfter(now)) {
        acc[id] = 'y';
      }
    }
    return acc;
  }, {});
}

// 다중 레이어 쿠키('chk_popup')에 특정 ID의 만료일을 설정
export function setHiddenPopupState(
  mainKey: string,
  subKey: string, // 숨길 layerId
  expireDays: number = 1,
  expireAtMidnight: boolean = false,
) {
  // 1. 이 ID의 새 만료일 타임스탬프 생성
  let expiryDate = dayjs().add(expireDays, 'day');
  if (expireAtMidnight) {
    expiryDate = expiryDate.endOf('day'); // 23:59:59.999 KST 기준 자정(다음날 00시) 직전
  }
  // 2. 현재 쿠키 값 전체 읽기
  const rawValue = getCookie(mainKey) || '';
  const value = decodeURIComponent(rawValue);
  const now = dayjs();

  // 3. 쿠키 값 파싱 및 수정
  const pairs = value ? value.split('&') : [];
  let found = false;

  const newExpiryTimestamp = expiryDate.format('YYYYMMDDHHmmss');

  const newPairs = pairs.map((pair) => {
    const parts = pair.split('=');
    if (parts.length === 2) {
      if (parts[0] === subKey) {
        found = true;
        return `${subKey}=${newExpiryTimestamp}`; // 값(만료일) 갱신
      } else if (now.isAfter(dayjs(parts[1]))) {
        // 만료일 지난 값 지워주기
        return '';
      }
    }
    return pair;
  });

  if (!found) {
    newPairs.push(`${subKey}=${newExpiryTimestamp}`); // 새 ID 추가
  }

  const newValue = newPairs.join('&');
  setCookie(mainKey, newValue, undefined, 365);
}
